import React, { useLayoutEffect, useState } from 'react'
import classNames from 'classnames'
import loaderColorFallback from 'assets/loader-color.gif'

import styles from './Loader.module.scss'

export enum LoaderSizes {
  ExtraSmall = 'Xs',
  Small = 'Sm',
  Medium = 'Md',
  Large = 'Lg',
}
interface ILoader {
  overlay?: boolean
  color?: boolean
  sizes?: LoaderSizes
  altImg?: string
  className?: string
  classes?: { loader?: string; logo?: string }
  children?: React.ReactNode
}

const resolveLoaderSrc = (useColor: boolean, assetsBase: string) => {
  if (!assetsBase) return loaderColorFallback
  return useColor
    ? `${assetsBase}/loader_color.webp`
    : `${assetsBase}/loader_grey.webp`
}

const Loader: React.FC<ILoader> = ({
  sizes = LoaderSizes.Medium,
  overlay = false,
  color = false,
  altImg = 'commons.loader.altImg',
  className = '',
  classes,
  children,
}) => {
  const assetsBase = process.env.REACT_APP_RANKMI_LOGO_URL || ''
  const [src, setSrc] = useState(() => resolveLoaderSrc(color, assetsBase))

  useLayoutEffect(() => {
    setSrc(resolveLoaderSrc(color, assetsBase))
  }, [color, assetsBase])

  const handleError = () => {
    setSrc((current) =>
      current === loaderColorFallback ? current : loaderColorFallback
    )
  }

  return (
    <div
      className={classNames(
        overlay && styles.overlay,
        `${styles[`${sizes}`]} ${className}`
      )}
    >
      <span className={classNames(styles.loader, classes?.loader)}>
        <img
          className={classNames(styles.logo, classes?.logo)}
          src={src}
          alt={altImg}
          onError={handleError}
        />
        {children}
      </span>
    </div>
  )
}

export default Loader
